<template>
  <div class="analyse" >
    <el-row class="mb20">
      <el-col :span="24">
        <el-card>
          <el-row>
            <el-col :span="10">
              <el-select v-model="orderPark" placeholder="选择园区" size="mini" clearable @change="handelParkChange">
                <el-option :value="1" label="上海园区"></el-option>
                <el-option :value="2" label="南京园区"></el-option>
                <el-option :value="3" label="徐州园区"></el-option>
                <el-option :value="6" label="北京园区"></el-option>
                <el-option :value="7" label="天津园区"></el-option>
                <el-option :value="8" label="江苏园区"></el-option>
                <el-option :value="9" label="浙江园区"></el-option>
                <el-option :value="10" label="广东园区"></el-option>
                <el-option :value="11" label="江西园区"></el-option>
                <el-option :value="12" label="山东园区"></el-option>
                <el-option :value="13" label="山西园区"></el-option>
                <el-option :value="14" label="河南园区"></el-option>
                <el-option :value="15" label="河北园区"></el-option>
                <el-option :value="16" label="湖南园区"></el-option>
                <el-option :value="17" label="湖北园区"></el-option>
                <el-option :value="18" label="贵州园区"></el-option>
                <el-option :value="19" label="陕西园区"></el-option>
                <el-option :value="20" label="四川园区"></el-option>
                <el-option :value="21" label="安徽园区"></el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <el-row class="mb20">
      <el-col :span="24">
        <el-card>
          <el-row class='text-r'>
            <el-col :span="24">
              <el-date-picker
                style="margin-left: .2rem"
                size='mini'
                v-model="orderDate"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                @change="orderFilter">
              </el-date-picker>
            </el-col>
          </el-row>
          <div class="charBox" ref="orderbox"></div>
        </el-card>
      </el-col>
    </el-row>
    <el-row class="mb20" :gutter="20">
      <el-col :span="24">
        <el-card>
          <div class="text-r" style="display: flex;" v-if="admin.indexOf(this.user.username)!== -1">
            <el-date-picker
              size='mini'
              style="margin-bottom: .4rem;margin-right: .2rem"
              v-model="weekDate"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              @change="handelParkChange2">
            </el-date-picker>
            <el-select
              :filterable="true"
              v-model="selectPeople"
              placeholder="选择人员"
              size="mini" clearable
              @change="handelParkChange3">
              <el-option :value="item.id" :label="item.username" v-for="(item,index) in ConversionPeople" :key="index"></el-option>
            </el-select>
          </div>
          <div class="charBox"  ref="CluesPercentage"></div>
        </el-card>
      </el-col>
    </el-row>
    <el-row class="mb20" :gutter="20">
      <el-col v-if="false" :span="12">
        <el-card>
          <el-row v-if="false">
            <el-col>
              <el-select v-model="addForm.uid" placeholder="请选择人员"  size='mini'  clearable>
                <el-option v-for="(item, index) in ConversionPeople"
                :key="index"
                :label="item.username"
                :value="item.id"
                @change="typeFilter">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <div class="charBox" ref="regTypebox"></div>
        </el-card>
      </el-col>
      <el-col :span="24">
        <el-card>
          <div class="charBox"  ref="statusbox"></div>
        </el-card>
      </el-col>
    </el-row>
    <el-row class="mb20" :gutter="20">
      <el-col :span="12">
        <el-card>
          <div class="text-r" style="display: flex;box-sizing: border-box;" v-if="admin.indexOf(this.user.username)!== -1">
            <el-date-picker
              style="margin-bottom: .4rem;width: 70%;"
              size='mini'
              v-model="weekDate2"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              @change="handelParkChange4">
            </el-date-picker>
            <el-select
              :filterable="true"
              v-model="selectPeople2"
              placeholder="选择人员"
              size="mini" clearable
              style="width: 30%;margin-left: .2rem"
              @change="handelParkChange5">
              <el-option :value="item.id" :label="item.username" v-for="(item,index) in ConversionPeople" :key="index"></el-option>
            </el-select>
          </div>
          <div class="charBox"  ref="ImGetPhoneBox"></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card>
          <div class="charBox" ref="Cluesbox" :style="admin.indexOf(this.user.username)!== -1 ? 'height:6.96rem' : '6rem'"></div>
        </el-card>
      </el-col>
    </el-row>
    <el-row class="mb20" :gutter="20">
      <el-col :span="8">
        <el-card class="cardBox" :class="{'activeBg': activeCard === 1}" @click.native="setActiveCard(1)">
          <div :class="activeCard === 1 ? 'activeCardColor' : 'cardColor'">
            <h4 class="cardBoxName">主营行业</h4>
<!--            <h4 class="cardBoxName">{{industryTotal}}</h4>-->
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="cardBox" :class="{'activeBg2': activeCard === 2}" @click.native="setActiveCard(2)">
          <div :class="activeCard === 2 ? 'activeCardColor' : 'cardColor'">
            <h4 class="cardBoxName">许可证</h4>
<!--            <h4 class="cardBoxName">{{licenceTotal}}</h4>-->
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="cardBox" :class="{'activeBg3': activeCard === 3}" @click.native="setActiveCard(3)">
          <div :class="activeCard === 3 ? 'activeCardColor' : 'cardColor'">
            <h4 class="cardBoxName">客户类型</h4>
<!--            <h4 class="cardBoxName">{{clientTypeTotal}}</h4>-->
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row class="mb20"  :gutter="20">
      <el-col :span="24">
        <el-card><div class="charBox" ref="integrationChar"></div></el-card>
      </el-col>
    </el-row>

    <el-row class="mb20" :gutter="20">
      <el-col :span="12">
        <el-card>
          <div class="charBox" ref="customTurnover"></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card>
          <div class="charBox" ref="isSpecialIndustry"></div>
        </el-card>
      </el-col>
    </el-row>
    <el-row class="mb20" :gutter="20">
      <el-col :span="12">
        <el-card>
          <div class="charBox" ref="customTrait"></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card>
          <div class="charBox" ref="customIntention"></div>
        </el-card>
      </el-col>
    </el-row>
    <el-row class="mb20" :gutter="20" v-if="false">
      <el-col :span="24">
        <div class="charBox" ref="CluesMapbox"></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
var echarts = require('echarts/lib/echarts')
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/component/legend')
require('echarts/lib/chart/themeRiver')
require('echarts/lib/chart/bar')
require('echarts/lib/chart/line')
require('echarts/lib/chart/pie')
// require('echarts/lib/component/visualMap')
export default {
  name: 'clues_analyse',
  props: {
    user: Object
  },
  data () {
    return {

      weekDate: '',
      weekDate2: '',
      addForm: {},
      selectPeople: '',
      selectPeople2: '',
      orderPark: '',
      ConversionPeople: [],
      activeCard: 1,
      orderChart: null,
      chart: null,
      orderStatusChart: null,
      proxyChart: null,
      cluesChart: null,
      CluesPercentageChart: null,
      ImGetPhoneChart: null,
      cluesMapChart: null,
      integrationChar: null,
      orderCount: [],
      industryCount: [],
      orderDay: [],
      orderDayCount: [],
      orderStatusCount: [],
      orderStatusHeader: [],
      proxyHeader: [],
      proxyCount: [],
      cluesHeader: [],
      cluesCount: [],
      cluesMapHeader: [],
      cluesMapCount: [],
      industryHeader: [],
      changeIndustryCount: [],
      industryTotal: 0,
      licenseHeader: [],
      licenseCount: [],
      licenseTotal: 0,
      clientTypeHeader: [],
      clientTypeCount: [],
      clientTypeTotal: 0,
      integrationHeader: [],
      integrationCount: [],
      integrationTitle: '主营行业',
      integrationColor: ['#5787FF'],
      orderDate: '',
      curDate: '',
      pickerOptions: {
        shortcuts: [
          {
            text: '最近7天',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近15天',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 15)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        onPick: ({maxDate, minDate}) => {
          this.curDate = minDate.getTime()
          if (maxDate) {
            this.curDate = ''
          }
        },
        disabledDate: (time) => {
          if (this.curDate) {
            const one = 30 * 24 * 3600 * 1000
            const minTime = this.curDate - one
            const maxTime = this.curDate + one
            return time.getTime() < minTime || time.getTime() > maxTime
          }
        }
      },
      admin: ['张六六', '常延龙', '李艳晴', '吕文飞', '李路路', '何涛', '沈阳', '杨宇璇', '毛宇明', '唐立阳'],
      setCluesPercentageCount: {},
      setImGetPhoneCount: [],
      setImGetPhoneHeader: ['上海', '非上海'],
      setImGetPhoneCountAll: 0,
      CustomTurnoverChart: null,
      customTurnoverCount: [],
      customTraitChart: null,
      customTraitCount: [],
      customIntentionChart: null,
      customIntentionCount: [],
      isSpecialChart: null,
      isSpecialCount: []
    }
  },
  computed: {
    collapse () {
      return this.$store.state.collapse
    }
  },
  watch: {
    orderStatusCount (val) {
      this.initCharts()
    },
    integrationCount (val) {
      this.initIntegrationChar()
    },
    orderDayCount (val) {
      this.initOrderChar()
    },
    setCluesPercentageCount (val) {
      this.initCluesPercentageChart()
    },
    setImGetPhoneCount (val) {
      this.initImGetPhoneChart()
    },
    customTurnoverCount (val) {
      this.initCustomTurnoverChart()
    },
    customTraitCount (val) {
      this.initCustomTraitChart()
    },
    customIntentionCount (val) {
      this.initCustomIntentionChart()
    },
    isSpecialCount (val) {
      this.initIsSpecialChart()
    }

  },
  methods: {
    handelParkChange2 (val) {
      this.getCluesPercentage(this.orderPark, this.selectPeople, val[0], val[1])
    },
    handelParkChange3 (val) {
      this.getCluesPercentage(this.orderPark, val, this.weekDate[0], this.weekDate[1])
    },
    handelParkChange4 (val) {
      this.setImGetPhone(this.orderPark, this.selectPeople2, val[0], val[1])
    },
    handelParkChange5 (val) {
      this.setImGetPhone(this.orderPark, val, this.weekDate2[0], this.weekDate2[1])
    },
    getCluesPercentage (garden, people, startTime, endTime) {
      let data = [garden, people, startTime, endTime]
      this.$axios.post('/api/threadstat/turn_success_filter', {val: data})
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.setCluesPercentageCount = data.data.weekTurnSuccess
          }
        })
    },
    setImGetPhone (garden, people, startTime, endTime) {
      let data = [garden, people, startTime, endTime]
      this.$axios.post('/api/threadstat/imget_filter', {val: data})
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.setImGetPhoneCount = data.data.imGetPhone
            this.setImGetPhoneCountAll = data.data.imGetPhone[0].value + data.data.imGetPhone[1].value
            // this.setImGetPhoneChartType()
          }
        })
    },
    getAnalysisData (type) {
      this.$axios.post('/api/threadstat/this_month', {garden: type})
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.orderDay = data.data.threadsCount.day
            this.orderDayCount = data.data.threadsCount.value
            this.ConversionPeople = data.data.users
            this.orderStatusCount = data.data.refercateCount.data
            this.orderStatusHeader = data.data.refercateCount.header
            this.cluesHeader = data.data.threadCrv.header
            this.cluesCount = data.data.threadCrv.value
            // this.cluesMapHeader = data.data.mapDistribute[0]
            // this.cluesMapCount = data.data.mapDistribute[1]
            this.setCluesPercentageCount = data.data.weekTurnSuccess
            this.setImGetPhoneCount = data.data.imGetPhone
            this.setImGetPhoneCountAll = data.data.imGetPhone[0].value + data.data.imGetPhone[1].value
            this.customTurnoverCount = data.data.customTurnover

            this.licenseHeader = data.data.licenseCount.header
            this.licenseCount = data.data.licenseCount.data
            // this.licenceTotal = data.data.licenceCount.total
            this.industryHeader = data.data.threadIndustryCount.header
            this.changeIndustryCount = data.data.threadIndustryCount.data
            // this.industryTotal = data.data.industryCount.total
            this.clientTypeHeader = data.data.customType.header
            this.clientTypeCount = data.data.customType.data
            // this.clientTypeTotal = data.data.clientTypeCount.total
            this.customTraitCount = data.data.customTrait
            this.customIntentionCount = data.data.customIntention
            this.isSpecialCount = data.data.isSpecialIndustry
            this.setActiveCard(1)
          }
        })
    },
    handelParkChange (val) {
      this.getAnalysisData(val)
    },
    initCharts () {
      // this.chart = echarts.init(this.$refs.chartbox, 'light')
      // this.setOption1()
      this.orderStatusChart = echarts.init(this.$refs.statusbox, 'light')
      this.setStatusbox()
      this.cluesChart = echarts.init(this.$refs.Cluesbox, 'light')
      this.setCluesType()
      this.CluesPercentageChart = echarts.init(this.$refs.CluesPercentage, 'light')
      this.setCluesPercentageType()
      this.ImGetPhoneChart = echarts.init(this.$refs.ImGetPhoneBox, 'light')
      this.setImGetPhoneChartType()
      // this.cluesMapChart = echarts.init(this.$refs.CluesMapbox, 'light')
      // this.setCluesMap()
      // this.proxyChart = echarts.init(this.$refs.regTypebox, 'light')
      // this.setProxyType()
    },
    initIntegrationChar () {
      this.integrationChar = echarts.init(this.$refs.integrationChar, 'light')
      this.setIntegration()
    },
    initOrderChar () {
      this.orderChart = echarts.init(this.$refs.orderbox, 'light')
      this.setOrderOption()
    },
    initCluesPercentageChart () {
      this.CluesPercentageChart = echarts.init(this.$refs.CluesPercentage, 'light')
      this.setCluesPercentageType()
    },
    initImGetPhoneChart () {
      this.ImGetPhoneChart = echarts.init(this.$refs.ImGetPhoneBox, 'light')
      this.setImGetPhoneChartType()
    },
    initCustomTurnoverChart () {
      this.CustomTurnoverChart = echarts.init(this.$refs.customTurnover, 'light')
      this.setCustomTurnoverChartType()
    },
    initIsSpecialChart () {
      this.isSpecialChart = echarts.init(this.$refs.isSpecialIndustry, 'light')
      this.setIsSpecialChartType()
    },
    initCustomTraitChart () {
      this.customTraitChart = echarts.init(this.$refs.customTrait, 'light')
      this.setCustomTraitChartType()
    },
    initCustomIntentionChart () {
      this.customIntentionChart = echarts.init(this.$refs.customIntention, 'light')
      this.setCustomIntentionChartType()
    },
    setOrderOption () {
      this.orderChart.setOption({
        title: {
          text: '线索数量'
        },
        xAxis: {
          boundaryGap: false,
          type: 'category',
          data: this.orderDay
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false
          }
        },
        series: [
          {
            data: this.orderDayCount,
            type: 'line',
            areaStyle: {},
            smooth: true,
            itemStyle: {
              normal: {
                areaStyle: {
                  type: 'default',
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: '#5787FF'
                    },
                    {
                      offset: 0.5,
                      color: '#98B7FF'
                    },
                    {
                      offset: 1,
                      color: '#DEEBFF'
                    }
                  ])
                },
                lineStyle: {
                  color: '#5B88EE'
                }
              }
            }
          }
        ],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        }
      })
    },
    setOption1 () {
      let option = {
        title: {
          text: '行业特点'
        },
        legend: {},
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        dataset: {
          dimensions: ['product', '含退款', '服务中及已完成'],
          source: this.industryCount
        },
        xAxis: {type: 'category'},
        yAxis: {
          splitLine: {
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        series: [
          {type: 'bar'},
          {type: 'bar'}
        ],
        color: ['#5787FF', '#C8E0FF']
      }
      this.chart.setOption(option)
    },
    randomColor () {
      var c = Math.floor(Math.random() * 256)
      while (c === 0 || c > 255) {
        c = Math.floor(Math.random() * 256)
      }
      return c
    },
    color16 () {
      var r = this.randomColor()
      var g = this.randomColor()
      var b = this.randomColor()
      var color = '#' + r.toString(16) + g.toString(16) + b.toString(16)
      return color
    },
    setStatusbox () {
      // let color = []
      // for (var a = 0; a < this.orderStatusHeader.length; a++) {
      //   color.push(this.color16())
      // }
      let option = {
        title: {
          text: '咨询分类'
        },
        color: ['#5787FF'],
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: this.orderStatusHeader,
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: '',
            type: 'bar',
            barWidth: '60%',
            data: this.orderStatusCount
          }
        ]
      }
      this.orderStatusChart.setOption(option)
    },
    setImGetPhoneChartType () {
      // let total = 0
      // let Name = []
      // this.setImGetPhoneCount.forEach((res) => {
      //   total += parseInt(res.value)
      //   Name.push(res.name)
      // })
      let option = {
        title: {
          text: 'IM套电数量'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
          // formatter: '{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          top: 30,
          data: this.setImGetPhoneHeader
        },
        series: [
          {
            name: 'IM套电数量',
            type: 'pie',
            center: ['50%', '60%'],
            radius: ['50%', '70%'],
            emphasis: {
              label: {
                show: true,
                fontSize: '30',
                fontWeight: 'bold'
              },
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            avoidLabelOverlap: false,
            color: ['#5787FF', '#C8E0FF'],
            label: {
              normal: {
                show: true,
                position: 'center',
                color: '#181818',
                formatter: '{value|' + this.setImGetPhoneCountAll + '}',
                // formatter: [
                //   { 'value|': + '￥' + total },
                //   { 'name|': Name }].join('\n'),
                rich: {
                  value: {
                    fontSize: 24,
                    fontFamily: '微软雅黑',
                    color: '#181818'
                  }
                }
              }
            },
            labelLine: {
              show: false
            },
            data: this.setImGetPhoneCount
          }
        ]
      }
      this.ImGetPhoneChart.setOption(option)
    },
    setCluesMap () {
      // var data = this.cluesMapCount
      // var geoCoordMap = this.cluesMapHeader
      // var convertData = function (data) {
      //   var res = [];
      //   for (var i = 0; i < data.length; i++) {
      //     var geoCoord = geoCoordMap[data[i].name];
      //     if (geoCoord) {
      //       res.push({
      //         name: data[i].name,
      //         value: geoCoord.concat(data[i].value)
      //       });
      //     }
      //   }
      //   return res
      // }
      // let option = {
      //   title: {
      //     text: '全国主要城市空气质量 - 百度地图',
      //     subtext: 'data from PM25.in',
      //     sublink: 'http://www.pm25.in',
      //     left: 'center'
      //   },
      //   tooltip : {
      //     trigger: 'item'
      //   },
      //   bmap: {
      //     center: [104.114129, 37.550339],
      //     zoom: 5,
      //     roam: true,
      //     mapStyle: {
      //       styleJson: [{
      //         'featureType': 'water',
      //         'elementType': 'all',
      //         'stylers': {
      //           'color': '#d1d1d1'
      //         }
      //       }, {
      //         'featureType': 'land',
      //         'elementType': 'all',
      //         'stylers': {
      //           'color': '#f3f3f3'
      //         }
      //       }, {
      //         'featureType': 'railway',
      //         'elementType': 'all',
      //         'stylers': {
      //           'visibility': 'off'
      //         }
      //       }, {
      //         'featureType': 'highway',
      //         'elementType': 'all',
      //         'stylers': {
      //           'color': '#fdfdfd'
      //         }
      //       }, {
      //         'featureType': 'highway',
      //         'elementType': 'labels',
      //         'stylers': {
      //           'visibility': 'off'
      //         }
      //       }, {
      //         'featureType': 'arterial',
      //         'elementType': 'geometry',
      //         'stylers': {
      //           'color': '#fefefe'
      //         }
      //       }, {
      //         'featureType': 'arterial',
      //         'elementType': 'geometry.fill',
      //         'stylers': {
      //           'color': '#fefefe'
      //         }
      //       }, {
      //         'featureType': 'poi',
      //         'elementType': 'all',
      //         'stylers': {
      //           'visibility': 'off'
      //         }
      //       }, {
      //         'featureType': 'green',
      //         'elementType': 'all',
      //         'stylers': {
      //           'visibility': 'off'
      //         }
      //       }, {
      //         'featureType': 'subway',
      //         'elementType': 'all',
      //         'stylers': {
      //           'visibility': 'off'
      //         }
      //       }, {
      //         'featureType': 'manmade',
      //         'elementType': 'all',
      //         'stylers': {
      //           'color': '#d1d1d1'
      //         }
      //       }, {
      //         'featureType': 'local',
      //         'elementType': 'all',
      //         'stylers': {
      //           'color': '#d1d1d1'
      //         }
      //       }, {
      //         'featureType': 'arterial',
      //         'elementType': 'labels',
      //         'stylers': {
      //           'visibility': 'off'
      //         }
      //       }, {
      //         'featureType': 'boundary',
      //         'elementType': 'all',
      //         'stylers': {
      //           'color': '#fefefe'
      //         }
      //       }, {
      //         'featureType': 'building',
      //         'elementType': 'all',
      //         'stylers': {
      //           'color': '#d1d1d1'
      //         }
      //       }, {
      //         'featureType': 'label',
      //         'elementType': 'labels.text.fill',
      //         'stylers': {
      //           'color': '#999999'
      //         }
      //       }]
      //     }
      //   },
      //   series : [
      //     {
      //       name: 'pm2.5',
      //       type: 'scatter',
      //       coordinateSystem: 'bmap',
      //       data: convertData(data),
      //       symbolSize: function (val) {
      //         return val[2] / 10;
      //       },
      //       encode: {
      //         value: 2
      //       },
      //       label: {
      //         formatter: '{b}',
      //         position: 'right',
      //         show: false
      //       },
      //       itemStyle: {
      //         color: 'purple'
      //       },
      //       emphasis: {
      //         label: {
      //           show: true
      //         }
      //       }
      //     },
      //     {
      //       name: 'Top 5',
      //       type: 'effectScatter',
      //       coordinateSystem: 'bmap',
      //       data: convertData(data.sort(function (a, b) {
      //         return b.value - a.value;
      //       }).slice(0, 6)),
      //       symbolSize: function (val) {
      //         return val[2] / 10;
      //       },
      //       encode: {
      //         value: 2
      //       },
      //       showEffectOn: 'render',
      //       rippleEffect: {
      //         brushType: 'stroke'
      //       },
      //       hoverAnimation: true,
      //       label: {
      //         formatter: '{b}',
      //         position: 'right',
      //         show: true
      //       },
      //       itemStyle: {
      //         color: 'purple',
      //         shadowBlur: 10,
      //         shadowColor: '#333'
      //       },
      //       zlevel: 1
      //     }
      //   ]
      // }
      // this.cluesMapChart.setOption(option)
    },
    setCluesType () {
      let option = {
        title: {
          text: '线索状态'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          right: 'right',
          data: this.cluesHeader
        },
        series: [
          {
            name: '线索状态',
            type: 'pie',
            radius: '55%',
            center: ['50%', '60%'],
            data: this.cluesCount,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ],
        color: ['#5787FF', '#C8E0FF', '#FFD8B4', '#AEA1FB']
      }
      this.cluesChart.setOption(option)
    },
    setCluesPercentageType () {
      let option = {
        title: {
          text: '业务线索转化情况'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          right: 'left',
          data: this.setCluesPercentageCount.header
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: this.setCluesPercentageCount.data
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: '已领取',
            type: 'bar',
            stack: '广告',
            barWidth: 30,
            data: this.setCluesPercentageCount.value1.data
          },
          {
            name: '已联系',
            type: 'bar',
            stack: '广告',
            barWidth: 30,
            data: this.setCluesPercentageCount.value2.data
          },
          {
            name: '已转化',
            type: 'bar',
            stack: '广告',
            barWidth: 30,
            data: this.setCluesPercentageCount.value3.data
          }
        ],
        color: ['#C8E0FF', '#5787FF', '#FFC68E']
      }
      this.CluesPercentageChart.setOption(option)
    },
    setProxyType () {
      let option = {
        title: {
          text: '本周转化率'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          right: 'right',
          data: this.proxyHeader
        },
        series: [
          {
            name: '代理记账需求',
            type: 'pie',
            radius: '55%',
            center: ['50%', '60%'],
            data: this.proxyCount,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ],
        color: ['#5787FF', '#C8E0FF', '#FFD8B4', '#AEA1FB']
      }
      this.proxyChart.setOption(option)
    },
    setActiveCard (val) {
      let title = ''
      let color = ''
      let header = []
      let count = []

      if (val === 1) {
        title = '主营行业'
        color = ['#5787FF']
        header = this.industryHeader
        count = this.changeIndustryCount
      } else if (val === 2) {
        title = '许可证'
        color = ['#FFC68E']
        header = this.licenseHeader
        count = this.licenseCount
      } else {
        title = '客户类型'
        color = ['#AEA1FB']
        header = this.clientTypeHeader
        count = this.clientTypeCount
      }

      this.activeCard = val
      this.integrationTitle = title
      this.integrationColor = color
      this.integrationHeader = header
      this.integrationCount = count
    },
    setIntegration () {
      let option = {
        title: {
          text: this.integrationTitle
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          data: this.integrationHeader
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.integrationHeader
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: this.integrationCount,
            type: 'bar',
            barWidth: 15
          }
        ],
        color: this.integrationColor
      }
      this.integrationChar.setOption(option)
    },
    setCustomTurnoverChartType () {
      let option = {
        title: {
          text: '年营业额',
          left: 'left'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          right: 'right'
        },
        series: [
          {
            name: '年营业额',
            type: 'pie',
            radius: '50%',
            data: this.customTurnoverCount,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      this.CustomTurnoverChart.setOption(option)
    },
    setIsSpecialChartType () {
      let option = {
        title: {
          text: '是否为特殊行业',
          left: 'left'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          right: 'right'
        },
        series: [
          {
            name: '是否为特殊行业',
            type: 'pie',
            radius: '50%',
            data: this.isSpecialCount,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      this.isSpecialChart.setOption(option)
    },
    setCustomTraitChartType () {
      let option = {
        title: {
          text: '客户性格',
          left: 'left'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          right: 'right'
        },
        series: [
          {
            name: '客户性格',
            type: 'pie',
            radius: '50%',
            data: this.customTraitCount,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      this.customTraitChart.setOption(option)
    },
    setCustomIntentionChartType () {
      let option = {
        title: {
          text: '客户意向',
          left: 'left'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          right: 'right'
        },
        series: [
          {
            name: '客户意向',
            type: 'pie',
            radius: '50%',
            data: this.customIntentionCount,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      this.customIntentionChart.setOption(option)
    },
    orderFilter (val) {
      this.$axios.post('/api/threadstat/row_filter', {val: [val[0], val[1], this.orderPark]})
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.orderDayCount = data.data.threadsCount.value
            this.orderDay = data.data.threadsCount.day
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    typeFilter (val) {
      this.$axios.post('/api/threadstat/crv_filter', {val: val})
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.orderDayCount = data.data.threadsCount.value
            this.orderDay = data.data.threadsCount.day
          } else {
            this.$message.error(data.msg)
          }
        })
    }
  },
  mounted () {
    this.getAnalysisData()
    this.getCluesPercentage()
  }
}
</script>

<style scoped lang="stylus">
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  .clearfix:before,
  .clearfix:after
  .text-r
      text-align: right
  .analyse
    marginLeft()
    .mb20
      margin-bottom: .4rem
    .charBox
      width: 100%
      height: 6rem
    .cardBox
      height: 2rem
      cursor: pointer
    .cardBoxDiv
      height: 100%
    .cardBoxName
      font-size: .4rem
      font-weight: 400
      line-height: .6rem
    .activeBg
      background-color: #5787FF !important
    .activeBg2
      background-color: #FFC68E !important
    .activeBg3
      background-color: #AEA1FB !important
    .cardColor
      color: #A2A2A2
    .activeCardColor
      color: #FFFFFF
</style>



// WEBPACK FOOTER //
// src/pages/clues_analyse/clues_analyse.vue